import CXMApiClient from "../../CXMApiClient";

const state = {
  PrintFormsModal: {
    ShowModal: false,
    ContactId: null,
    ContactName: null,
    PlatformId: null
  }
};

const getters = {};

const actions = {
  openPrintFormsModal(context, data) {
    context.commit("openPrintFormsModal", data);
  },
  closePrintFormsModal(context) {
    context.commit("closePrintFormsModal");
  },
  async getPacketsForDealer(context, requestPayload) {
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient
      .ProcessRequest("POST", "/api/packet/search", requestPayload)
      .catch(error => error.response);
    return response;
  },
  async getFormsForDealer(context, requestPayload) {
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient
      .ProcessRequest("POST", "/api/form/search", requestPayload)
      .catch(error => error.response);
    return response;
  },
  async getFormById(context, formId) {
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient
      .ProcessRequest("GET", `/api/form/${formId}`)
      .catch(error => error.response);
    return response;
  },
  async renderFormForContact(context, requestPayload) {
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient
      .ProcessRequest("POST", "/api/form/render", requestPayload)
      .catch(error => error.response);
    return response;
  }
};

const mutations = {
  openPrintFormsModal(context, data) {
    state.PrintFormsModal.ContactId = data.ContactId;
    state.PrintFormsModal.ContactName = data.ContactName;
    state.PrintFormsModal.PlatformId = data.PlatformId;
    state.PrintFormsModal.ShowModal = true;
  },
  closePrintFormsModal(state) {
    state.PrintFormsModal.ShowModal = false;
    state.PrintFormsModal.ContactId = null;
    state.PrintFormsModal.ContactName = null;
    state.PrintFormsModal.PlatformId = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Forms.js